import React, { useRef } from 'react';
import { motion } from 'framer-motion';
import { useInView } from 'framer-motion';
import { AlertTriangleIcon } from 'lucide-react';
export function ProblemSection() {
  const ref = useRef(null);
  const isInView = useInView(ref, {
    once: true,
    margin: '-100px'
  });
  return <section ref={ref} className="w-full py-16 md:py-24 bg-[#1e3a8a]" data-id="element-89">
      <div className="container mx-auto px-4 md:px-6 lg:px-8 max-w-5xl" data-id="element-90">
        <motion.div initial={{
        opacity: 0,
        y: 30
      }} animate={isInView ? {
        opacity: 1,
        y: 0
      } : {}} transition={{
        duration: 0.6
      }} className="space-y-8" data-id="element-91">
          <div className="flex items-center gap-4 mb-8" data-id="element-92">
            <AlertTriangleIcon className="w-10 h-10 text-[#f97316]" data-id="element-93" />
            <h2 className="text-3xl md:text-4xl lg:text-5xl font-bold text-white" data-id="element-94">
              El verdadero problema no es tu producto
            </h2>
          </div>

          <div className="space-y-6 text-[#faf8f5] text-lg md:text-xl leading-relaxed" data-id="element-95">
            <p data-id="element-96">
              El problema no es tu producto. El problema es que estás tratando
              de venderle a desconocidos en un mercado saturado sin tener una
              oferta validada.
            </p>

            <p data-id="element-97">
              Estás escondido detrás de publicaciones en redes sociales que
              nadie ve, esperando que el algoritmo te salve la vida.
            </p>

            <p className="font-semibold text-white" data-id="element-98">
              Esa angustia de no generar ingresos rápidos mata la motivación de
              cualquier emprendedor.
            </p>

            <p className="text-xl font-bold text-[#f97316]" data-id="element-99">
              Sin ventas, tu negocio es solo un pasatiempo caro, y la
              frustración empieza a afectar tu confianza y tu cuenta bancaria.
            </p>
          </div>
        </motion.div>
      </div>
    </section>;
}